import { Options, Vue } from 'vue-class-component';

import Sider from './components/sider/index.vue';
import Header from './components/header/index.vue';
import AppMain from './components/main/index.vue';

import Debounced from '@/utils/tool';
import request from "@/utils/jcRequest";

@Options({
  components: {
    Sider,
    Header,
    AppMain,
  }
})
export default class Login extends Vue {
  public activeName = 'firstss222'; // 选中文案 默认位 用户密码

  private debouncedUse: Function = new Debounced().use(this.dd, 1000)

  public cc() {
    this.debouncedUse();
  }
  public dd() {
    console.log(4444);

  }
  public created(){
   // if (this.$route.path === "/backStageHome") this.$router.push("/backstage/menu");
  }
}